import { render } from "./PhotoReportItem.vue?vue&type=template&id=c284f5a0&scoped=true"
import script from "./PhotoReportItem.vue?vue&type=script&lang=js"
export * from "./PhotoReportItem.vue?vue&type=script&lang=js"

import "./PhotoReportItem.vue?vue&type=style&index=0&id=c284f5a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c284f5a0"]])

export default __exports__